import {
    Background,
    CFlex,
    CMargin,
    DText,
    Flex,
} from "../../../../styles/CommonStyles";
import Text from "../../../../core/utils/Text";
import Input from "../../../common/input/Input";
import ActionButton from "../../../common/buttons/ActionButton";
import { useEffect, useMemo, useState } from "react";
import { useQueryContext } from "../../../../core/contexts/query";
import Select from "../../../common/dropdown/Select";
import {
    useAddSuggestion,
    useDeleteSuggestion,
    useGetSuggestionById,
    useUpdateSuggestion,
} from "../../../../core/services/react-query/setting/suggestion";
import {
    useGetAnalyzeAssistants,
    useGetAnalyzePairs,
} from "../../../../core/services/react-query/setting/analyze";

const emptyLangField = [
    { language: "fa", value: "" },
    { language: "en", value: "" },
];

const initialState = {
    pair_id: "",
    assistant_id: "",
    title: emptyLangField,
    subtitle: emptyLangField,
    description: emptyLangField,
};

const SuggestionModal = ({
    onSuccess,
    type = "add", // add | edit | delete
    _suggestion,
}) => {

    const { data: assistantsData } = useGetAnalyzeAssistants();
    const [marketType, setMarketType] = useState("");

    const { data: pairsData, refetch: refetchPairs, isLoading: isPairsLoading } = useGetAnalyzePairs({
        params: { market_type: marketType },
        enabled: !!marketType,
    });


    const {
        data: suggestionData,
        isLoading: getSuggestionLoading,
    } = useGetSuggestionById(_suggestion?.id, {
        enabled: type === "edit" && !!_suggestion?.id,
    });

    const { mutate: addSuggestion, isLoading: addLoading } =
        useAddSuggestion(onSuccess);

    const { mutate: updateSuggestion, isLoading: updateLoading } =
        useUpdateSuggestion(onSuccess);

    const { mutate: deleteSuggestion, isLoading: deleteLoading } =
        useDeleteSuggestion(onSuccess);

    const { setToast } = useQueryContext();

    const [form, setForm] = useState(initialState);


    // --- Prefill edit ---
    useEffect(() => {
        if (type === "edit" && suggestionData) {
            const data = suggestionData;

            const fa = data.translations?.fa || {};
            const en = data.translations?.en || {};

            setForm({
                pair_id: data.pair?.id || "",
                assistant_id: data.assistant?.id || "",
                title: [
                    { language: "fa", value: fa.title || "" },
                    { language: "en", value: en.title || "" },
                ],
                subtitle: [
                    { language: "fa", value: fa.subtitle || "" },
                    { language: "en", value: en.subtitle || "" },
                ],
                description: [
                    { language: "fa", value: fa.description || "" },
                    { language: "en", value: en.description || "" },
                ],
            });
        }
    }, [suggestionData, type]);

    useEffect(() => {
        if (!form.assistant_id) {
            setMarketType("");
            return;
        }

        const selectedAssistant = assistantsData?.data?.find(a => a.id === form.assistant_id);
        if (!selectedAssistant) return;

        setMarketType(selectedAssistant.market_type);

    }, [form.assistant_id, assistantsData]);

    useEffect(() => {
        if (marketType) {
            refetchPairs()
        }
    }, [marketType])

    const onLangChange = (key, lang, value) => {
        setForm((prev) => ({
            ...prev,
            [key]: prev[key].map((item) =>
                item.language === lang ? { ...item, value } : item
            ),
        }));
    };

    const validAction = useMemo(() => {
        if (type === "delete") return true;

        return (
            form.pair_id &&
            form.assistant_id &&
            form.title.every((t) => t.value) &&
            form.subtitle.every((t) => t.value) &&
            form.description.every((t) => t.value)
        );
    }, [form, type]);

    const onAction = () => {
        if (!validAction) {
            setToast({ message: "fill-inputs-error", isError: true, show: true });
            return;
        }

        if (type === "add") {
            addSuggestion(form);
        }

        if (type === "edit") {
            updateSuggestion({
                id: _suggestion.id,
                data: form,
            });
        }

        if (type === "delete") {
            deleteSuggestion({ id: _suggestion.id });
        }

        setToast({
            message:
                type === "delete"
                    ? "suggestion-deleted"
                    : type === "edit"
                        ? "suggestion-updated"
                        : "suggestion-added",
            isError: false,
            show: true,
        });
    };

    const pairOptions =
        pairsData?.data?.map((p) => ({
            label: p.symbol,
            value: p.id,
        })) || [];

    const assistantOptions =
        assistantsData?.data?.map((a) => ({
            label: a.type,
            value: a.id,
        })) || [];

    // 👇 این دو تا رو اضافه کن
    const selectedPairLabel =
        pairOptions.find((p) => p.value === form.pair_id)?.label || "";

    const selectedAssistantLabel =
        assistantOptions.find((a) => a.value === form.assistant_id)?.label || "";

    return (
        <CFlex fw>
            <DText main fontSize={"b"}>
                <Text tid={`${type}-suggestion`} />
            </DText>

            {type !== "delete" && (
                <div className="grid grid-cols-2 gap-2 w-full">
                    <div className="col-span-1">
                        <Select
                            value={selectedAssistantLabel}
                            onValueChange={(idx) =>
                                setForm((s) => ({
                                    ...s,
                                    assistant_id: assistantOptions[idx]?.value,
                                }))
                            }
                            placeHolder="Select Assistant"
                            options={assistantOptions.map((a) => a.label)}
                        />
                    </div>

                    <div className="grid-cols-1">

                        <Select

                            value={isPairsLoading ? "Loading..." : selectedPairLabel}
                            onValueChange={(idx) =>
                                setForm((s) => ({
                                    ...s,
                                    pair_id: pairsData?.data[idx]?.id,
                                }))
                            }
                            placeHolder={isPairsLoading ? "Loading..." : "Select Pair"}
                            options={!isPairsLoading && (pairsData?.data?.map(p => p.symbol) || [])}

                        />
                    </div>




                    {["title", "subtitle", "description"].map((field) => (

                        <Background key={field} bg={"mainBg"} className="col-span-2 ">
                            <Input
                                height={"40px"}
                                value={form[field].find((f) => f.language === "fa")?.value}
                                onInputChange={(v) => onLangChange(field, "fa", v)}
                                label={`${field}-fa`}
                            />
                            <Input
                                height={"40px"}
                                value={form[field].find((f) => f.language === "en")?.value}
                                onInputChange={(v) => onLangChange(field, "en", v)}
                                label={`${field}-en`}
                            />
                        </Background>
                    ))}
                </div>
            )}

            {type === "delete" &&
                <div className="grid grid-cols-2 gap-2 w-full">
                    <DText main>
                        <Text tid="آیا از حذف این مورد مطمئن هستید؟" />
                    </DText>
                </div>}

            <CMargin margin={"10px"} />

            <ActionButton
                active={validAction}
                height={"42px"}
                onClick={onAction}
                loading={addLoading || updateLoading || deleteLoading || getSuggestionLoading}
            >
                <Text tid={type === "delete" ? "remove" : "submit"} />
            </ActionButton>
        </CFlex>
    );
};

export default SuggestionModal;